module.exports = __webpack_public_path__ + "img/personal-info-gray.222fc34f.svg";